import { MenuProps, Menu, Affix } from 'antd';
import React, { useState } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { openSidebar, selectTheme } from '../../features/theme/themeSlice';
import { RootState } from '../../app/store';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
): MenuItem {
    return {
    key,
    icon,
    children,
    label,
    type,
    } as MenuItem;
}

const PlayVirtualSideMenu = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
    const theme = useAppSelector(selectTheme);
    const [hidden, sethidden] = useState(false);

    const onClick: MenuProps['onClick'] = (e) => {
        theme.isMobile && dispatch(openSidebar(false));
        navigate('/playsrvirtual', { state: { gameId: `${e.key}` }})
    };

    const items: MenuProps['items'] = [
        getItem(<>
                    <span className='group-title'>Virtual Sports</span>
                    <span className="close-x" onClick={(e) => {e.preventDefault(); sethidden(true); dispatch(openSidebar(false))}}>X</span>
                </>, 'grp', null, [
            getItem('', 'vfb', <img src='/images/bundesliga.svg' alt='bundesliga' style={{width: "60%"}}/>),
            getItem('Football Leagues', 'sub1', <img src='/images/football-leagues.svg' alt='football' className='item-icon'/>, [
                getItem('England', 'vfel', <img src='/images/football-england.svg' alt='football' className='item-icon'/>)
        ]),
        getItem('Football Cups', 'sub2', <img src='/images/football-leagues.svg' alt='football' className='item-icon'/>, [
            getItem('World', 'vfwc', <img src='/images/football-world.svg' alt='football' className='item-icon'/>),
            getItem('Euros', 'vfec', <img src='/images/football-euro.svg' alt='football' className='item-icon'/>),
            getItem('Champions', 'vfcc', <img src='/images/football-champions.svg' alt='football' className='item-icon'/>),
            getItem('Asian', 'vfas', <img src='/images/football-asian.svg' alt='football' className='item-icon'/>),
        ]),
        getItem('', 'vbl', <img src='/images/nba.png' alt='nba' style={{height: "60%", width: "20%"}}/>),
        ], 'group'),
        getItem(<span className='group-title'>Virtual Live/In-Play Sports</span>, 'grp1', null, [
            getItem('', 'vbi', <img src='/images/mlb.svg' alt='mlb' className='item-icon-1'/>),
            getItem('Tennis', 'vti', <img src='/images/tennis.svg' alt='tennis' className='item-icon'/>),
        ], 'group'),
    ];
    
    return (
        <>
            <Menu
                onClick={onClick}
                className="virtual-side-bar hpage"
                mode="inline"
                items={items}
                style={{display: hidden ? 'none' : 'block'}}
            />
            <Affix offsetTop={140}>
                <div
                    className="pointer not-visible-tabs-bar-sidebar-button"
                    onClick={e => {
                        e.preventDefault();
                        sethidden(false);
                        dispatch(openSidebar(true));
                    }}
                >
                <FontAwesomeIcon icon={faChevronRight} />
                </div>
            </Affix>
        </>
    )
}

export default PlayVirtualSideMenu